module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    attrs: {
      "name": _vm.name
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad2fb508","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/Summernote.vue
// module id = 365
// module chunks = 0